/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderDTO } from './orderDTO';


export interface BasePaginationRequest { 
    page?: number;
    size?: number;
    sort?: string;
    orderDTOList?: Array<OrderDTO>;
}

